<script lang="ts" setup>
import { useFlag } from '@unleash/proxy-client-vue'
import type { MobileProductCellType } from '~/stores/global'

const globalStore = useGlobalStore()
const { t } = useI18n()
const { event } = useEvent()

const isMosaicViewEnabled = useFlag('storefront.mosaic-view')

const setDisplay = (display: MobileProductCellType) => {
  globalStore.config.mobileProductCellVariant = display

  event(`product_catalog_home_${display}_view_click`)
}
</script>

<template>
  <div class="flex justify-end gap-0 text-[12px] font-medium">
    <RBaseButton
      class="button p-2 text-gray-300"
      color="none"
      :class="{ 'button--active': globalStore.config.mobileProductCellVariant === 'grid' }"
      :aria-label="t('globals.productCellTypes.grid')"
      @click="setDisplay('grid')"
    >
      <RIcon size="20" name="material-symbols:grid-view-outline-rounded" />
    </RBaseButton>

    <RBaseButton
      v-if="isMosaicViewEnabled"
      class="button p-2 text-gray-300"
      color="none"
      :class="{ 'button--active': globalStore.config.mobileProductCellVariant === 'mosaic' }"
      :aria-label="t('globals.productCellTypes.mosaic')"
      @click="setDisplay('mosaic')"
    >
      <RIcon size="20" name="material-symbols:auto-awesome-mosaic-outline" />
    </RBaseButton>
    <RBaseButton
      class="button p-2 text-gray-300"
      color="none"
      :class="{ 'button--active': globalStore.config.mobileProductCellVariant === 'list' }"
      :aria-label="t('globals.productCellTypes.list')"
      @click="setDisplay('list')"
    >
      <RIcon size="20" name="material-symbols:menu-rounded" />
    </RBaseButton>
  </div>
</template>

<style scoped>
.button--active {
  color: var(--color-primary) !important;
}
</style>
